export const LOADING = 'Loading...';

export const EMPTY_STRING = '';

export const FETCH_HEADER = 'Fetch history';

export enum Sizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum IconTypeNames {
  PDF = 'file-pdf',
  WORD = 'file-word',
  HTML = 'html5',
  DOWN = 'down',
  FILE = 'file',
  LINK = 'link',
  USER = 'user',
  LOCK = 'lock',
  CHECK = 'check',
  PRINTER = 'printer',
  DOWNLOAD = 'download',
  TIFF = 'file-image',
}

export enum FileFormatNames {
  PDF = 'pdf',
  DOC = 'doc',
  HTML = 'html',
  TIFF = 'tiff',
}

export enum ExportFormatNames {
  TEXT = 'txt',
  HTML = 'html',
  DOC = 'doc',
  PDF = 'pdf',
}

export enum TableSizeNames {
  SMALL = 'small',
  DEFAULT = 'default',
  MEDIUM = 'medium',
}

export enum ButtonShapes {
  CIRCLE = 'circle',
  ROUND = 'round',
  CIRCLE_OUTLINE = 'circle-outline',
}

export enum ButtonTypes {
  DEFAULT = 'default',
  LINK = 'link',
  GHOST = 'ghost',
  PRIMARY = 'primary',
  DASHED = 'dashed',
  DANGER = 'danger',
}

export enum InputTypes {
  RADIO_GROUP = 'radioGroup',
  CHECK_BOX = 'checkbox',
  RADIO = 'radio',
  SELECT = 'select',
  AUTOCOMPLETE = 'autoComplete',
  INPUT_NUMBER = 'inputNumber',
  PASSWORD = 'password',
  DATE_PICKER = 'datePicker',
}

export const notSupportedMessage = 'Function not available in this browser';
